module.exports = __webpack_public_path__ + "static/media/icon-arrow-up-green.8d560644.svg";